(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    document.addEventListener('invalid', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.id.startsWith('ym-artwork-')) return;
    event.preventDefault();
    const card = input.closest('.ym-upload-card');
    card?.classList.add('ym-artwork-missing');
    card?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    card?.querySelector('.ym-upload-trigger')?.focus();
  }, true);
  document.addEventListener('change', (event) => {
    const input = event.target;
    if (input instanceof HTMLInputElement && input.id.startsWith('ym-artwork-') && input.files?.length) input.closest('.ym-upload-card')?.classList.remove('ym-artwork-missing');
  });

  if (!window.ymNativeArtworkSubmissionInstalled) {
    window.ymNativeArtworkSubmissionInstalled = true;
    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.id.startsWith('BuyButtons-ProductForm-')) return;
      const artwork = Array.from(form.elements).find(input => input instanceof HTMLInputElement && input.type === 'file' && input.name === 'properties[Artwork]');
      if (!artwork?.files?.length) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (!form.reportValidity()) return;
      HTMLFormElement.prototype.submit.call(form);
    }, true);
  }
  if (!window.ymArtworkSelectionInstalled) {
    window.ymArtworkSelectionInstalled = true;
    document.addEventListener('change', (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || input.type !== 'file' || !input.id.startsWith('ym-artwork-')) return;
      const card = document.querySelector('.ym-upload-card label[for="' + CSS.escape(input.id) + '"]')?.closest('.ym-upload-card');
      if (!card) return;
      const file = input.files?.[0];
      const initial = card.querySelector('.ym-upload-initial');
      const selected = card.querySelector('[data-ym-upload-selected]');
      const image = card.querySelector('[data-ym-upload-image]');
      const icon = card.querySelector('[data-ym-upload-file-icon]');
      if (image.dataset.objectUrl) { URL.revokeObjectURL(image.dataset.objectUrl); delete image.dataset.objectUrl; }
      initial.hidden = !!file; selected.hidden = !file;
      if (!file) { image.hidden = true; image.removeAttribute('src'); icon.hidden = false; return; }
      card.querySelector('[data-ym-upload-name]').textContent = file.name;
      const supported = /^(image\/png|image\/jpeg|image\/svg\+xml)$/.test(file.type);
      image.hidden = !supported; icon.hidden = supported;
      if (supported) { const url = URL.createObjectURL(file); image.dataset.objectUrl = url; image.src = url; }
    });
  }
  if (!customElements.get('ym-sticker-config')) {
    customElements.define('ym-sticker-config', class extends HTMLElement {
      connectedCallback() {
        this.sizeControl = this.querySelector('[data-ym-size]');
        this.shapeControl = this.querySelector('[data-ym-shape]');
        this.quantityControl = this.querySelector('[data-ym-quantity]');
        if (!this.sizeControl || !this.shapeControl || !this.quantityControl) return;
        this.customMode = false;
        this.customEntry = this.querySelector('[data-ym-custom-entry]');
        this.customWidth = this.querySelector('[data-ym-custom-width]');
        this.customHeight = this.querySelector('[data-ym-custom-height]');
        this.updateCustom = () => {
          if (!this.customMode) return;
          const w = Number(this.customWidth.value), h = Number(this.customHeight.value);
          const es = document.documentElement.lang.toLowerCase().startsWith('es');
          const message = this.querySelector('[data-ym-custom-message]');
          const bucket = [1, 2, 2.5, 3, 4, 5, 6].find(n => n >= Math.max(w, h));
          const native = this.querySelector('.ym-sticker-option--3 select');
          const shape = this.shapeControl.value;
          const nativeOption = bucket && native && Array.from(native.options).find(o => {
            const parts = o.value.split(' · ');
            return parts[0] === shape && parseFloat(parts[1]) === bucket;
          });
          const valid = w >= 1 && h >= 1 && w <= 6 && h <= 6 && !!nativeOption;
          const warning = es ? 'Introduce ancho y alto disponibles entre 1 y 6 pulgadas.' : 'Enter available width and height from 1 to 6 inches.';
          this.customWidth.setCustomValidity(valid || !this.customWidth.value || !this.customHeight.value ? '' : warning);
          message.textContent = valid ? (es ? 'Precio según tamaño de ' + bucket + ' pulgadas.' : 'Priced at the ' + bucket + ' inch size.') : warning;
          if (valid) {
            const size = nativeOption.value.split(' · ')[1];
            if (this.sizeControl.value !== size) { this.sizeControl.value = size; this.sizeControl.dispatchEvent(new Event('change', {bubbles:true})); }
          }
        };
        this.setCustomMode = (enabled) => {
          this.customMode = enabled; this.customEntry.hidden = !enabled;
          for (const input of [this.customWidth, this.customHeight]) { input.disabled = !enabled; input.required = enabled; input.setCustomValidity(''); }
          if (enabled) this.updateCustom();
          this.renderButtons(this.sizeControl, 'size');
        };
        this.customWidth.addEventListener('input', this.updateCustom);
        this.customHeight.addEventListener('input', this.updateCustom);
        this.onControlChange = (event) => {
          if (event.target === this.quantityControl) {
            const quantity = this.querySelector('.ym-sticker-option--2 select');
            if (!quantity) return;
            quantity.value = this.quantityControl.value;
            quantity.dispatchEvent(new Event('change', { bubbles: true }));
            return;
          }
          const native = this.querySelector('.ym-sticker-option--3 select');
          if (!native) return;
          const value = this.shapeControl.value + ' · ' + this.sizeControl.value;
          const options = Array.from(native.options);
          let option = options.find(item => item.value === value);
          if (!option && event.target === this.shapeControl) {
            const matchingShape = options.filter(item => item.value.split(' · ')[0] === this.shapeControl.value);
            option = matchingShape.find(item => parseFloat(item.value.split(' · ')[1]) === parseFloat(this.sizeControl.value)) || matchingShape[0];
          } else if (!option && event.target === this.sizeControl) {
            const matchingSize = options.filter(item => item.value.split(' · ')[1] === this.sizeControl.value);
            const rectangular = /^(Ovalado|Rectangular)$/.test(this.shapeControl.value);
            option = matchingSize.find(item => /^(Ovalado|Rectangular)$/.test(item.value.split(' · ')[0]) === rectangular) || matchingSize[0];
          }
          if (!option) {
            this.syncControls();
            return;
          }
          native.value = option.value;
          native.dispatchEvent(new Event('change', { bubbles: true }));
        };
        this.sizeControl.addEventListener('change', this.onControlChange);
        this.quantityControl.addEventListener('change', this.onControlChange);
        this.shapeControl.addEventListener('change', this.onControlChange);
        this.shapeControl.addEventListener('change', () => { if (this.customMode) setTimeout(this.updateCustom, 0); });
        this.addEventListener('change', event => { if (this.customMode && (event.target === this.quantityControl || event.target.matches('.ym-finish-cards input'))) setTimeout(this.updateCustom, 0); });
        const updateQuote = () => {
          const w = this.querySelector('[data-ym-width]')?.value;
          const h = this.querySelector('[data-ym-height]')?.value;
          const link = this.querySelector('[data-ym-custom-quote]');
          if (!link) return;
          const message = 'Hola, quisiera una cotización de stickers personalizados. Medida: ' + (w || '___') + ' x ' + (h || '___') + ' pulgadas. Cantidad: ' + this.quantityControl.value + '. Forma: ' + this.shapeControl.value + '. Acabado: ___.';
          link.href = 'https://wa.me/14085091733?text=' + encodeURIComponent(message);
        };
        this.querySelectorAll('[data-ym-width], [data-ym-height]').forEach(input => input.addEventListener('input', updateQuote));
        this.addEventListener('change', updateQuote);
        updateQuote();
        this.syncControls();
        this.observer = new MutationObserver(() => this.syncControls());
        const picker = this.querySelector('variant-picker');
        if (picker) this.observer.observe(picker, {
          subtree: true, childList: true, attributes: true,
          attributeFilter: ['selected', 'checked', 'data-current-checked']
        });
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.sizeControl?.removeEventListener('change', this.onControlChange);
        this.quantityControl?.removeEventListener('change', this.onControlChange);
        this.shapeControl?.removeEventListener('change', this.onControlChange);
      }
      syncControls() {
        const quantity = this.querySelector('.ym-sticker-option--2 select');
        if (quantity) {
          this.fillControl(this.quantityControl, Array.from(quantity.options).map(option => option.value));
          this.quantityControl.value = quantity.value;
        }
        const native = this.querySelector('.ym-sticker-option--3 select');
        if (!native) return;
        const values = Array.from(native.options).map(option => option.value.split(' · '));
        const shapes = [...new Set(values.map(parts => parts[0]))];
        const sizes = [...new Set(values.map(parts => parts[1]).filter(Boolean))].sort((a, b) => parseFloat(a) - parseFloat(b));
        this.fillControl(this.sizeControl, sizes);
        this.fillControl(this.shapeControl, shapes);
        const selected = native.value.split(' · ');
        this.shapeControl.value = selected[0];
        this.sizeControl.value = selected[1];
        this.renderButtons(this.shapeControl, 'shape');
        this.renderButtons(this.sizeControl, 'size');
        this.renderButtons(this.quantityControl, 'quantity');
      }
      renderButtons(control, name) {
        const group = this.querySelector('[data-ym-buttons="' + name + '"]');
        if (!group) return;
        if (name === 'size') {
          const es = document.documentElement.lang.toLowerCase().startsWith('es');
          const shape = this.shapeControl.value;
          const rectangular = /^(Ovalado|Rectangular)$/.test(shape);
          const cards = [1, 2, 2.5, 3, 4].map((n, index) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'ym-visual-button ym-size-card';
            const option = Array.from(control.options).find(o => {
              const parts = o.value.match(/([\d.]+)\s*[×x]\s*([\d.]+)/);
              return parts && Number(parts[1]) === n && (rectangular ? Number(parts[2]) !== n : Number(parts[2]) === n);
            });
            const title = document.createElement('strong');
            title.textContent = n + '″';
            const sub = document.createElement('small');
            sub.textContent = es ? ['X-small', 'Small', 'Mediano', 'Grande', 'X-largo'][index] : ['X-small', 'Small', 'Medium', 'Large', 'X-large'][index];
            if (!option) button.setAttribute('aria-label', n + (es ? ' pulgadas, próximamente' : ' inches, coming soon'));
            button.append(title, sub);
            button.disabled = !option;
            button.setAttribute('aria-pressed', String(!this.customMode && !!option && option.value === control.value));
            if (option) button.addEventListener('click', () => { this.setCustomMode(false); control.value = option.value; control.dispatchEvent(new Event('change', { bubbles:true })); });
            return button;
          });
          const custom = document.createElement('button');
          custom.type = 'button'; custom.className = 'ym-visual-button ym-size-card';
          custom.setAttribute('aria-pressed', String(this.customMode));
          custom.addEventListener('click', () => this.setCustomMode(true));
          const title = document.createElement('strong'); title.textContent = es ? 'Personalizado' : 'Custom';
          const sub = document.createElement('small'); sub.textContent = es ? 'Tu medida' : 'Your size';
          custom.append(title, sub);
          group.replaceChildren(...cards, custom);
          return;
        }
        group.replaceChildren(...Array.from(control.options).map(option => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'ym-visual-button ym-visual-button--' + name;
          button.dataset.value = option.value;
          if (name === 'shape') {
            const icon = document.createElement('span');
            icon.className = 'ym-shape-icon';
            icon.setAttribute('aria-hidden', 'true');
            button.append(icon);
          }
          const label = document.createElement('span');
          label.textContent = option.textContent;
          button.append(label);
          button.setAttribute('aria-pressed', String(option.value === control.value));
          button.addEventListener('click', () => {
            control.value = option.value;
            control.dispatchEvent(new Event('change', { bubbles: true }));
          });
          return button;
        }));
      }
      fillControl(control, values) {
        if (Array.from(control.options).map(option => option.value).join('|') === values.join('|')) return;
        control.replaceChildren(...values.map(value => {
          const option = document.createElement('option');
          option.value = value;
          const displayValues = {
            Circular: this.dataset.ymCircle,
            Cuadrado: this.dataset.ymSquare,
            Troquelado: this.dataset.ymDieCut,
            Transparente: this.dataset.ymClear
          };
          option.textContent = displayValues[value] || value.replace('pulgadas', this.dataset.ymUnit);
          return option;
        }));
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ym-order-summary"] && !Shopify.designMode) return;
  try {
    if (!window.ymSummaryUpdateInstalled) {
    window.ymSummaryUpdateInstalled = true;
    let sequence = 0;
    document.addEventListener('shopify:product:select', (event) => {
      if (!(event.target instanceof Element) || !event.target.closest('ym-sticker-config')) return;
      const summary = document.querySelector('[data-ym-live-summary]');
      if (!summary || !event.promise) return;
      const request = ++sequence;
      summary.style.visibility = 'hidden';
      event.promise.then(({ detail }) => {
        if (request !== sequence) return;
        const price = detail?.html?.querySelector('product-price [ref="priceContainer"] bdi');
        const amount = detail?.resource?.price;
        const displayPrice = price?.textContent.trim() || (Number.isFinite(Number(amount)) ? new Intl.NumberFormat('en-US', {style:'currency',currency:'USD'}).format(Number(amount) / 100) : '');
        if (!displayPrice) { summary.style.display = 'none'; return; }
        const heading = summary.querySelector('p strong');
        if (heading) {
          const old = heading.textContent;
          heading.textContent = old.replace(/\$[\d,.]+(?:\s*USD)?/, displayPrice);
        }
        const unit = summary.querySelector('[data-ym-unit]');
        const selectedQuantity = document.querySelector('ym-sticker-config [data-ym-quantity]');
        const count = Number(selectedQuantity?.value);
        if (unit && Number.isFinite(Number(amount)) && count > 0) {
          const unitPrice = new Intl.NumberFormat('en-US', {style:'currency', currency:'USD'}).format(Number(amount) / 100 / count);
          unit.textContent = unitPrice + (document.documentElement.lang.toLowerCase().startsWith('es') ? ' por sticker' : ' per sticker');
        }
        for (const item of event.selectedOptions || []) {
          const row = [...summary.querySelectorAll('dl div')].find(el => el.querySelector('dt')?.textContent.trim() === item.name);
          if (row?.querySelector('dd')) row.querySelector('dd').textContent = item.value;
        }
        summary.style.display = '';
        summary.style.visibility = '';
      }).catch(() => { if (request === sequence) summary.style.display = 'none'; });
    });
  }
  } catch(e) { console.error(e); }
})();

})();
